import React, { useState } from "react";
import { Download } from "lucide-react";
import { Button } from "../../components/ui/button";
import {
  DialogPDF,
  DialogContentPDF,
  DialogHeaderPDF,
  DialogTitlePDF,
  DialogTriggerPDF,
} from "../../components/ui/dialog-pdf";
import PdfComponent from "./PdfComponent";
import { ScrollArea } from "../../components/ui/scroll-area";
import "./PDFDialogButton.css";

const PDFDialogButton = ({
  BtnStyle,
  BtnText,
  BtnTextStyle,
  pdfUrl,
  DownloadFileName,
  showIcon,
  DownloadIcon,
  DownloadIconStyle,
  ShowBtnText = true,
  showDownloadButton = false,
}) => {
  const [pdfError, setPdfError] = useState("");

  const showError = () => {
    setPdfError("PDF not available");
    setTimeout(() => setPdfError(""), 2500);
  };

  async function handleDownload() {
    try {
      const response = await fetch(pdfUrl);
      if (!response.ok) throw new Error("PDF not available");

      const blob = await response.blob();
      if (!blob || blob.size === 0) throw new Error("Empty PDF");

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${DownloadFileName}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      showError();
    }
  }

  const isPdfAvailable = pdfUrl && pdfUrl !== "NA";

  return (
    <div className={`relative ${showDownloadButton ? "flex items-center gap-2" : ""}`}>
      {isPdfAvailable ? (
        <DialogPDF>
          <DialogTriggerPDF asChild>
            <Button variant="outline" className={BtnStyle}>
              {showIcon && (
                <img
                  src={DownloadIcon}
                  alt="PDF Icon"
                  className={DownloadIconStyle}
                  style={{height:"1rem", width:"auto"}}
                />
              )}
              {ShowBtnText && (
                <div className={BtnTextStyle}>{BtnText}</div>
              )}
            </Button>
          </DialogTriggerPDF>

          <DialogContentPDF className="sm:max-w-[36rem] max-w-[22rem] h-[85vh] flex flex-col p-0 m-0 rounded-t-2xl">
            <DialogHeaderPDF className="flex flex-col h-full overflow-hidden">
              <DialogTitlePDF className="px-4 pt-4 pb-2 shrink-0 text-base">Notes</DialogTitlePDF>
              <div className="flex flex-col flex-1 overflow-hidden p-0 m-0">
                <div className="flex-1 overflow-y-auto overscroll-contain px-2 pb-2">
                  <PdfComponent pdf={pdfUrl} />
                </div>
              </div>
            </DialogHeaderPDF>
          </DialogContentPDF>
        </DialogPDF>
      ) : (
        <Button
          variant="outline"
          className={BtnStyle}
          onClick={showError}
        >
          {showIcon && (
            <img
              src={DownloadIcon}
              alt="PDF Icon"
              className={DownloadIconStyle}
            />
          )}
          {ShowBtnText && <div className={BtnTextStyle}>{BtnText}</div>}
        </Button>
      )}
      {showDownloadButton && isPdfAvailable && (
        <Button
          type="button"
          variant="outline"
          className="border border-[#5A277C] text-[#5A277C] px-2 py-[3px] rounded-full text-xs font-medium whitespace-nowrap hover:bg-[#5A277C] hover:text-white transition"
          onClick={handleDownload}
          aria-label={`Download ${DownloadFileName || "PDF"}`}
          title={`Download ${DownloadFileName || "PDF"}`}
        >
          <Download size={16} aria-hidden="true" />
        </Button>
      )}

      {/* Error message */}
      {pdfError && (
        <div
          className="absolute top-full left-1/2 -translate-x-1/2 mt-2
               px-4 py-2 bg-black/90 text-white
               text-sm font-medium rounded-lg shadow-lg
               animate-fade-in"
        >
          {pdfError}
        </div>
      )}

    </div>
  );
};

export default PDFDialogButton;
